module.exports = __webpack_public_path__ + "static/media/deno.ff256ac7.svg";